export const profile = {
	residence: "Alberta, Canada",
	industry: "Cloud Security and DevOps",
	employment: "Senior Software Engineer at Cisco",
	education: "BSc. Computer Engineering",
	university: "University of Alberta",
	experience: "6",
};
